import { collection, query, where, getDocs, limit } from 'firebase/firestore';
import { db } from '../firebase/config';

/**
 * Sertifika numarasına göre sertifika bilgilerini sorgular
 * @param {string} certificateNumber - Sertifika numarası
 * @returns {Promise<Object|null>} Sertifika bilgileri veya null
 */
export const queryCertificate = async (certificateNumber) => {
  try {
    if (!certificateNumber || certificateNumber.trim().length === 0) {
      return null;
    }

    const normalizedNumber = certificateNumber.trim().toUpperCase();
    
    // Optimize: limit(1) ekleyerek sadece bir sonuç getir
    const certificatesRef = collection(db, 'certificates');
    const q = query(
      certificatesRef, 
      where('certificateNumber', '==', normalizedNumber),
      limit(1)
    );
    
    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      return null;
    }

    // İlk eşleşen sertifikayı al
    const doc = querySnapshot.docs[0];
    const data = doc.data();

    // Tarihleri optimize şekilde Date objelerine çevir
    const convertTimestamp = (timestamp) => {
      if (!timestamp) return null;
      if (timestamp.toDate && typeof timestamp.toDate === 'function') {
        return timestamp.toDate();
      }
      if (timestamp.seconds) {
        return new Date(timestamp.seconds * 1000);
      }
      return new Date(timestamp);
    };

    const issueDate = convertTimestamp(data.issueDate);
    const expiryDate = convertTimestamp(data.expiryDate);
    const auditDate = convertTimestamp(data.auditDate);

    // Geçerlilik durumunu hesapla
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    
    let status = 'Valid';
    if (expiryDate) {
      const expiry = new Date(expiryDate);
      expiry.setHours(23, 59, 59, 999);
      if (currentDate > expiry) {
        status = 'Invalid';
      }
    }

    return {
      id: doc.id,
      companyName: data.companyName || '',
      companyAddress: data.companyAddress || '',
      standards: data.standards || [],
      auditDate: auditDate,
      issueDate: issueDate,
      expiryDate: expiryDate,
      status: status,
      scope: data.scope || '',
      certificateNumber: data.certificateNumber || normalizedNumber
    };
  } catch (error) {
    console.error('Certificate query error:', error);
    throw error;
  }
};

